// extracted by mini-css-extract-plugin
export default {"xs":"575px","sm":"767px","md":"991px","lg":"1199px","xl":"1599px"};